import request from '@/utils/request';
//标题头
export function loadNavs() {
    return request({
        url: '/public/loadNavs',
        method: 'post',
    });
}



// WEBPACK FOOTER //
// ./src/api/header.js